<div class="app__addDocument-card-wrapper p-4">
  <div class="flex justify-between items-center mb-3">
    <p class="text-base m-0 text-[#010b18] font-bold">Linked Documents</p>
    <div class="flex">
      @if(has_document && suggested_documents?.length > 0){
      <button
        [disabled]="isRemoveEditSaveSharing"
        (click)="!isRemoveEditSaveSharing && suggestedDocument()"
        class="mx-1.5 rounded-md bg-[#C8D5EE] text-[#25508E] font-bold text-xs"
        [ngClass]="{
          'opacity-[0.6] hover:cursor-default': isRemoveEditSaveSharing,
          'hover:bg-[#5D80C7] hover:text-[#FFFFFF] hover:cursor-pointer': !isRemoveEditSaveSharing
        }"
        style="height: 26px; padding: 0 9px"
      >
        Checklist
      </button>
      }

      <button
        class="flex items-center bg-transparent mx-1.5 rounded-md font-bold text-xs leading-[24px]"
        [ngClass]="{
          'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
          'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing
        }"
        [disabled]="isRemoveEditSaveSharing"
        (click)="!isRemoveEditSaveSharing && openFileUpload()"
      >
        <img
          style="margin: 0 6px; width: 15px"
          [src]="isRemoveEditSaveSharing ? 'assets/images/upload-file-inbox-gray.svg' : 'assets/images/upload-file-inbox-blue.svg'"
        />
        Upload Files
      </button>
    </div>
  </div>
  <upload-document-selection
    [nonDocumentAttachmentList]="nonDocumentAttachmentList"
    (uploadDocumentSelectionEmitter)="uploadDocumentSelectionEmitter($event)"
    [disableSearch]="isRemoveEditSaveSharing"
  >
  </upload-document-selection>
  <div class="flex items-center justify-between mt-2">
    <div class="flex items-center gap-1">
      <mat-checkbox
        *ngIf="!isRemoveEditSaveSharing"
        class="app__common--multiple--selection--checkbox"
        [(ngModel)]="selectAll"
        (change)="onSelectAllChange($event.checked)"
        [disabled]="linkedDocuments.length === 0"
      ></mat-checkbox>
      <span class="flex items-center text-[#898F9E] font-semibold text-sm m-0" [ngClass]="{ 'ml-2 mt-3': isRemoveEditSaveSharing }">
        Linked Documents &nbsp;<span class="text-[#25508E] font-bold text-sm">({{ linkedDocuments.length }})</span>
      </span>
    </div>
    <div>
      <button
        class="flex font-semibold text-sm bg-transparent leading-[24px]"
        [ngStyle]="{
          background: !isRemoveEditSaveSharing ? 'linear-gradient(rgb(62, 117, 255), rgb(132, 0, 255), rgb(227, 103, 255))' : 'none',
          '-webkit-background-clip': !isRemoveEditSaveSharing ? 'text' : 'none',
          '-webkit-text-fill-color': !isRemoveEditSaveSharing ? 'transparent' : 'inherit'
        }"
        [ngClass]="{
          'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
          'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing
        }"
        (click)="!isRemoveEditSaveSharing && reprocessAll()"
      >
        <span class="material-icons" style="margin-right: 4px">refresh</span>
        Reprocess All
      </button>
    </div>
  </div>
  <div
    (drop)="dragged($event)"
    (dragstart)="onDragStart($event)"
    (drag)="onDrag($event)"
    (dragover)="onDrag($event)"
    (dragend)="onDragEnd($event)"
    (dragleave)="myFunction($event)"
    (click)="!isRemoveEditSaveSharing && fileInput.click()"
    style="overflow: hidden auto !important"
    class="text-center h-[220px] max-h-[812px]"
  >
    <input hidden type="file" #fileInput multiple (change)="uploadFile($event)" />
    @if(isActiveDrag || linkedDocuments.length == 0){
    <div class="bg-[#EBF0FA] border-dashed rounded-sm border-2 text-center h-[220px] mt-[14px]">
      <img src="assets/images/upload-image-icon-form.svg" class="p-2 bg-[#FFFFFF] rounded-full mb-[12px] mt-[64px]" />
      <p class="m-auto leading-9 text-sm font-normal text-[#515765]">
        <span class="font-bold text-[#25508e]">Drag and Drop</span> or <span class="font-bold text-[#25508e]">Browse files</span> from your current
        device
      </p>
    </div>
    } @if(linkedDocuments.length && !isActiveDrag){
    <div class="flex flex-wrap gap-2" [ngClass]="{ 'mt-2': !isRemoveEditSaveSharing, 'mt-5': isRemoveEditSaveSharing }">
      @for(file of linkedDocuments; track file.id; let i = $index){
      <div class="flex items-center gap-4" (mouseenter)="hoveredFile = file" (mouseleave)="hoveredFile = null">
        <div
          *ngIf="!(file?.is_suggestion && shareTypeData)"
          [ngClass]="{ 'ai-border-grid': file?.is_suggestion }"
          class="image-div-container border border-[#D3DCE8] rounded-[10px] pt-1"
          style="width: 224px; height: 300px"
        >
          <div class="files-list relative">
            @if(hoveredFile === file ){
            <div
              style="border-radius: 10px 10px 0px 0px"
              class="absolute top-[0px] left-[1px] z-[10] bg-[#00000095] width-[220px] h-[254px] min-w-[220px] flex justify-center items-center"
            >
              <div class="flex flex-col gap-2">
                @if(!isRemoveEditSaveSharing){ @if(!file?.is_suggestion){
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="viewFile(file); $event.stopPropagation()"
                >
                  View Document</button
                >}@else{
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="attachDocument(file); $event.stopPropagation()"
                >
                  Attach Document
                </button>
                } @if(!file?.is_suggestion){
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="deleteForm(file); $event.stopPropagation()"
                >
                  Unlink Document
                </button>
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="downloadFile(file); $event.stopPropagation()"
                >
                  Download
                </button>
                <button
                  (mouseenter)="isHovered = true"
                  (mouseleave)="isHovered = false"
                  style="display: flex; line-height: 24px; padding-top: 4px; justify-content: center"
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] complex-template-ai-explore-ai-btn--hover hover:bg-[#fff] hover:text-[#25508E]"
                  [ngClass]="{
                    'complex-template-ai-explore-ai-btn--hover': isHovered
                  }"
                  (click)="reprocessFile(file); $event.stopPropagation()"
                >
                  <mat-icon style="margin-right: 4px">refresh</mat-icon>
                  Reprocess
                </button>
                }@else{
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="viewFile(file); $event.stopPropagation()"
                >
                  View Document
                </button>
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="deleteForm(file); $event.stopPropagation()"
                >
                  Remove Suggestion
                </button>
                }} @else{
                <button
                  class="bg-transparent text-white text-[12px] font-semibold w-[128px] rounded border border-[#FFFFFF] h-[36px] hover:bg-[#fff] hover:text-[#25508E]"
                  (click)="downloadFile(file); $event.stopPropagation()"
                >
                  Download
                </button>
                }
              </div>
            </div>
            }
            <div class="absolute flex gap-1 items-center h-6 z-[10] top-3 cursor-pointer" *ngIf="!isRemoveEditSaveSharing">
              <mat-checkbox
                type="checkbox"
                class="checkbox-input"
                [(ngModel)]="file.selected"
                (click)="$event.stopPropagation()"
                (change)="onValueChange($event, file, i)"
              ></mat-checkbox>
            </div>
            <!-- <div class="absolute right-3 flex gap-1 items-center h-6 z-[1] top-3 cursor-pointer" *ngIf="file?.document_date">
              <span class="setup-tag-container text-sm h-[27px]" [matTooltip]="file?.document_date | date">
                <span class="text-sm">
                  {{ file?.document_date | date }}
                </span>
              </span>
            </div> -->

            <div class="donwlaod-continer">
              <div style="display: flex; flex-direction: column">
                <file-extension-preview
                  style="width: 100%; background-color: #f4f4f4; border-radius: 8px 8px 0px 0px; cursor: pointer; text-align: center"
                  [IconName]="nmaterialIconName(file)"
                  [link]="file?.link"
                  [is_large_icon]="true"
                  [link_available]="true"
                  [file]="file"
                  [is_medium_preview]="true"
                  [formFileExtension]="true"
                  [isActive]="false"
                >
                </file-extension-preview>
              </div>

              <div
                class="mobile-divdownload-cross"
                style="height: 56px; display: flex; justify-content: space-between; border-top: 1px solid rgba(211, 220, 232, 0.7); padding: 6px 12px"
              >
                <div class="flex flex-col">
                  <p
                    class="text-[13px] font-bold text-[#010B18] m-0"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 25px"
                    [matTooltip]="file?.form_name"
                  >
                    {{ file?.form_name | truncateStrPipe : 20 }}
                  </p>
                  @if(file?.is_suggestion){
                  <p
                    class="text-[10px] font-medium m-0 text-base text-[#010B18]"
                    style="
                      background: linear-gradient(180deg, #3e75ff, #8400ff, #e367ff);
                      -webkit-background-clip: text;
                      background-clip: text;
                      font-size: 12px !important;
                      -webkit-text-fill-color: transparent;
                      position: relative;
                      top: -4px;
                    "
                  >
                    Kinnect Ai Suggestion
                  </p>

                  }@else{
                  <p
                    class="text-[10px] font-medium text-[#898F9E] m-0"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 25px"
                    [matTooltip]="file?.type"
                  >
                    {{ file?.type | truncateStrPipe : 20 }}
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  <!-- @if(selectedFiles.length > 0){
<non-doc-float-acation [selectedFiles]="selectedFiles" (actionEmitter)="onActionEmitter($event)"></non-doc-float-acation>
} -->
</div>
